import * as React from 'react'
import { SettingsBodyResourcesListBodyMonitoring } from './SettingsBodyResourcesListBodyMonitoring'
import { SettingsApplication } from '../../model'
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource'
import FixedTable from '@mulesoft/anypoint-components/lib/FixedTable'
import Status from '@mulesoft/monitoring-center-components/lib/components/Status/Status'
import '../SettingsBodyResourcesList.css'

export type ValueProps = {
  filteredResources?: SettingsApplication[],
  isLoadingResources: boolean
}

export type EventProps = {
  onEnableCheckbox?: (id: string) => void
  onApply?: (amEnabled: boolean, app: SettingsApplication) => void
}

export type Props = ValueProps & EventProps

export const getAppStatus = (status: string, deploymentStatus?: string) => {
  return deploymentStatus ? deploymentStatus : status;
}

export const getResourcesListColumns = (props: Props) => {
  return [
    {
      key: 'name',
      name: 'Name',
      renderer: (app: SettingsApplication) => {
        const testId = app.name + '-app-name';
        return (<label data-test-id={testId}>{app.name}</label>)
      }
    },
    {
      key: 'status',
      name: 'Status',
      disableSort: true,
      width: 200,
      renderer: (app: SettingsApplication) => {
        const status = getAppStatus(app.status, app.deploymentUpdateStatus)
        return (
          <div data-test-id={app.name + '-status'}>
            <Status value={status} resourceType={ResourceType.CLOUDHUB_APPLICATION}/>
          </div>
        )
      }
    },
    {
      key: 'amEnabled',
      name: 'Monitoring',
      disableSort: true,
      width: 250,
      renderer: (app: SettingsApplication) => {
        const {onEnableCheckbox, onApply} = props
        return (<SettingsBodyResourcesListBodyMonitoring app={app} onEnableCheckbox={onEnableCheckbox} onApply={onApply} />)
      }
    },
  ]
}

export const SettingsBodyResourcesListBody = (props: Props) => {
  const {filteredResources, isLoadingResources} = props
  const data = filteredResources ? filteredResources : []
  
  return (
    <div className="settings-body-resources-list">
      <FixedTable
        testId="settings-body-resources-list"
        className={'no-scrollbar'}
        columns={getResourcesListColumns(props)}
        data={data}
        isLoading={isLoadingResources}
      />
    </div>
  )
}
